export function backToNational() {
  const title = document.getElementById('rpTitle');
  if (title) title.textContent = 'Dashboard';
  const national = document.getElementById('rp-national');
  const detail   = document.getElementById('rp-detail');
  if (national) national.style.display = 'block';
  if (detail)   detail.style.display   = 'none';
}

/**
 * On desktop the right panel collapses to width 0 (.closed). On mobile it
 * lives off-canvas as a drawer (.open / not). Toggle the right one.
 */
export function toggleRightPanel() {
  const rp = document.getElementById('rpanel');
  if (!rp) return;
  if (window.matchMedia('(max-width: 900px)').matches) {
    toggleDrawer('rpanel');
  } else {
    rp.classList.toggle('closed');
  }
}

/**
 * Mobile-only: open or close one of the two off-canvas drawers
 * (`sidebar` or `rpanel`), with a tappable backdrop that closes them.
 */
export function toggleDrawer(which) {
  const el = document.getElementById(which === 'sidebar' ? 'sidebar' : 'rpanel');
  if (!el) return;
  // The sidebar element doesn't have an id by default — give it one
  if (which === 'sidebar' && !el.id) el.id = 'sidebar';

  const opening = !el.classList.contains('open');

  // Close the other drawer if it was open (only one at a time on mobile)
  const other = document.getElementById(which === 'sidebar' ? 'rpanel' : 'sidebar');
  other?.classList.remove('open');

  el.classList.toggle('open', opening);
  ensureBackdrop().classList.toggle('show', opening);
}

function ensureBackdrop() {
  let bd = document.getElementById('navBackdrop');
  if (!bd) {
    bd = document.createElement('div');
    bd.id = 'navBackdrop';
    bd.className = 'nav-backdrop';
    bd.addEventListener('click', closeAllDrawers);
    document.body.appendChild(bd);
  }
  return bd;
}

export function closeAllDrawers() {
  document.getElementById('sidebar')?.classList.remove('open');
  document.getElementById('rpanel')?.classList.remove('open');
  document.getElementById('navBackdrop')?.classList.remove('show');
}
